import React, { useState } from "react";
import ProjectCard from "./ProjectCard";
import projectsData from "./projectData";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Fade,
  Flip,
  Bounce,
  JackInTheBox,
  Rotate,
  Roll,
  Slide,
  Zoom,
} from "react-awesome-reveal";
import "../CSS_folder/Project.css"

function Projects() {
  const projectsPerPage = 1;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPageCount = Math.ceil(projectsData.length / projectsPerPage);
  const startIndex = (currentPage - 1) * projectsPerPage;
  const endIndex = startIndex + projectsPerPage;
  const projectsToShow = projectsData.slice(startIndex, endIndex);

  const loadMoreProjects = () => {
    if (currentPage < totalPageCount) {
      setCurrentPage(currentPage + 1);
    }
  };

  const showLessProjects = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="projectsContainer">
      <div className="projects">
        {projectsToShow.map((project, index) => (
          <Fade>
            <ProjectCard project={project} />
          </Fade>
        ))}
      </div>

      <div className="arrowButtons">
        {currentPage == 1 ? (
          <>
            {" "}
            <div>{currentPage}/13</div>
            <ArrowForwardIosIcon
              className="arrowButton"
              onClick={loadMoreProjects}
            />
          </>
        ) : (
          <>
            {" "}
            <ArrowBackIosIcon
              className="arrowButton"
              onClick={showLessProjects}
            />
            <span>{currentPage}/13</span>
            {currentPage < totalPageCount && (
              <ArrowForwardIosIcon
                className="arrowButton"
                onClick={loadMoreProjects}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Projects;
